// extracted by mini-css-extract-plugin
module.exports = {"error":"SharedStyles-module__error--30QdD","heading":"SharedStyles-module__heading--1jc0A","headingText":"SharedStyles-module__headingText--3SPBb"};